import React, { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { Navigate, NavLink, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import { types } from "store/actions/authActions";
import { OtpCodeInput } from "components/Custom/Forms/OtpCodeInput";
import authApi from "services/apis/authApi";
import { OTP_TIME } from "constants/coreConst";
import StorageManager from "utils/storageManager";
import ROUTES from "routes/constant";

export const OTP_SCREEN_TYPE = {
  FORGOT_PASSWORD: "forgot_password",
};

const AuthOTP = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locationState = location.state;

  const [verificationOtp, setVerificationOtp] = useState();
  const [status, setStatus] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const inputRef = useRef();

  useEffect(() => {
    inputRef?.current?.focus();
  }, []);

  const minutes = 0;
  const seconds = 45;
  const [[mins, secs], setTime] = React.useState([minutes, seconds]);

  const currDate = moment(
    StorageManager.get("otpSentTime") ?? moment().toISOString()
  );

  const tick = () => {
    if (secs > 0) {
      const time = moment().diff(currDate, "seconds");

      setTime([mins, OTP_TIME - time]);
    }
  };

  const reset = () => setTime([parseInt(minutes), parseInt(seconds)]);

  // DO NOT REMOVE THIS CODE
  const resendOtp = async () => {
    setIsSendingOtp(true);
    if (locationState?.type === OTP_SCREEN_TYPE.FORGOT_PASSWORD) {
      setVerificationOtp("");
      await authApi
        .generateOtpForForgotPassword({
          emailId: locationState?.username,
        })
        .then(() => {
          StorageManager.set("otpSentTime", moment().toISOString());
        });
    } else {
      try {
        setVerificationOtp("");

        await authApi
          .loginAdmin({
            username: locationState.username,
            password: locationState.password,
          })
          .then(() => {
            StorageManager.set("otpSentTime", moment().toISOString());
          });

        reset();
      } catch (error) {
        /* empty */
      }
    }

    setIsSendingOtp(false);
  };

  useEffect(() => {
    const timerId = setInterval(() => tick(), 1000);
    return () => clearInterval(timerId);
  }, [secs, mins]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (locationState?.type === OTP_SCREEN_TYPE.FORGOT_PASSWORD) {
      try {
        await authApi.verifyForgotPasswordOTP({
          emailId: locationState?.username,
          otp: verificationOtp,
        });

        toast.success("OTP verified!!");

        navigate(ROUTES.AUTH.RESET_PASSWORD, {
          state: {
            username: locationState?.username,
            otp: verificationOtp,
          },
        });
      } catch (error) {
        /* empty */
      }
    } else {
      try {
        const { data, status } = await authApi.loginOTPVerify({
          emailId: locationState.username,
          password: locationState.password,
          otp: verificationOtp,
          latitude: locationState?.latitude,
          longitude: locationState?.longitude,
          location: locationState?.location,
        });

        if (status === 200) {
          setStatus(false);

          localStorage.setItem("token", `${data.token}`);
          localStorage.setItem("superAdminId", `${data.superAdminId}`);
          dispatch({ type: types.LOGIN_SUCCESS });

          navigate(`/dashboard`);
        } else if (status === 400) {
          setStatus(true);
          toast.error("Please enter valid OTP");
        } else {
          setStatus(true);
          toast.error("Error from the server. Please try again later!");
        }
      } catch (error) {
        setStatus(true);
      }
    }
  };

  if (locationState?.username === undefined) {
    return <Navigate to={"/"} replace />;
  }

  return (
    <>
      {/* {err && <Alert variant="danger">{err}</Alert>} */}
      <Form onSubmit={handleSubmit}>
        <div className="form-container">
          <div className="heading ">
            <h5>The OTP is sent on Mobile/Mail</h5>
            <h6>Enter the valid OTP number</h6>
          </div>

          <div className="text-center my-4">
            <OtpCodeInput
              value={verificationOtp}
              onValueChange={setVerificationOtp}
              containerClassName="mb-5"
            />
          </div>
          {status ? (
            <h6 className="text-danger" style={{ height: "35" }}>
              Please Enter Correct OTP
            </h6>
          ) : null}
        </div>

        <Button
          type="submit"
          className="btn ripple btn-main-primary btn-block mb-2 text-uppercase"
        >
          SUBMIT
        </Button>
        <div className="form-group text-center">
          {`${secs.toString().padStart(2)}` > 0 ? (
            <b style={{ color: "#004e5c" }}>
              {mins.toString().padStart(2, "0")} :{" "}
              {secs.toString().padStart(2, "0")}
            </b>
          ) : isSendingOtp ? (
            <b className="cursor-pointer">Sending...</b>
          ) : (
            <b
              className="cursor-pointer"
              onClick={() => {
                resendOtp();
              }}
            >
              Resend OTP
            </b>
          )}
        </div>
        <div className="form-group text-center">
          <NavLink to={ROUTES.AUTH.LOGIN}>
            Back to <b>Log-in</b>
          </NavLink>
        </div>
      </Form>
    </>
  );
};

export default AuthOTP;
